var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumenFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 64,
    viewBox: "0 0 47 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.3112 38.9456V30.645C45.3112 27.8146 44.2771 25.1001 42.4364 23.0986C40.5958 21.0972 38.0993 19.9728 35.4962 19.9728H31.1339C30.2662 19.9728 29.4341 19.598 28.8205 18.9309C28.2069 18.2637 27.8622 17.3589 27.8622 16.4154V11.6722C27.8622 8.84176 26.8282 6.12725 24.9875 4.12582C23.1468 2.12439 20.6503 1 18.0472 1H12.5944M19.1378 1H4.96052C3.15455 1 1.68884 2.59372 1.68884 4.5574V59.1043C1.68884 61.0679 3.15455 62.6617 4.96052 62.6617H42.0395C43.8455 62.6617 45.3112 61.0679 45.3112 59.1043V29.4592C45.3112 21.9114 42.5536 14.6727 37.6452 9.33551C32.7367 3.99837 26.0794 1 19.1378 1Z",
    stroke: "#595959",
    strokeWidth: 1.61564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumenFile);
export default __webpack_public_path__ + "static/media/documenFile.5a5dd820808ce30c7b44a7f52d38c718.svg";
export { ForwardRef as ReactComponent };